import { createSelector } from 'reselect';
import { RootState } from 'typesafe-actions';
import { PlanListState } from './reducer';
import { PlanList } from 'PlanList-Types';

import { getItemFeatures } from '@travel/traveler-core/utils/jrdpHelper';

export const getErrors = (state: RootState) => state.planList.errors;

export const getPlanList = (state: RootState) => state.planList;

export const getPlanListData = createSelector(
  getPlanList,
  (state: PlanListState) => state.planList,
);

export const getIsFetching = createSelector(
  getPlanList,
  (state: PlanListState) => state.isFetching,
);

export const hasMorePlans = createSelector(getPlanListData, (plans: PlanList) => {
  const { offset, total, limit } = plans;
  return total > offset + limit;
});

export const getFeaturesByItemId = (planId: string, itemId: string) => (state: RootState) => {
  const plan = state.planList.planList.plans.find(plan => plan.planId === planId);
  const item = plan?.items.find(planItem => planItem.itemId === itemId);
  const featureGroups = item?.featureGroups || [];
  return getItemFeatures(featureGroups);
};

export const getPrefetchedFilters = createSelector(getPlanList, (state: PlanListState) => ({
  filters: state.prefetchedPlanList?.filters,
  total: state.prefetchedPlanList?.total,
}));

export const getIsFetchingFilters = createSelector(
  getPlanList,
  (state: PlanListState) => state.isFetchingFilters,
);

export const getIsFetchingMorePlans = createSelector(
  getPlanList,
  (state: PlanListState) => state.isFetchingMorePlans,
);
